export class Timer {
    timer: any;

    callback: Function;
    timeout: number;

    constructor(callback: Function, timeout: number) {
        this.callback = callback;
        this.timeout = timeout;
    }

    start = () => {
        if (!this.timer) {
            this.stop();
            this.timer = setInterval(this.callback, this.timeout);
        }
    };

    stop = () => {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    };

    reset = () => {
        this.stop();
        this.start();
    };
}
